import React, { useState } from 'react';

const Input = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  error,
  label,
  required = false,
  className = '',
  maxLength,
  showCounter = false,
  icon,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const inputClasses = `input-field ${error ? '!border-red-400 focus:!border-red-500' : ''} ${icon ? 'pe-10' : ''} ${className}`;

  return (
    <div className="w-full">
      {label && (
        <label className={`block text-sm font-medium mb-2 transition-colors duration-200 ${
          isFocused ? 'text-blue-600' : 'text-gray-700'
        }`}>
          {label}
          {required && <span className="text-red-500 mr-1">*</span>}
        </label>
      )}

      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          disabled={disabled}
          className={inputClasses}
          maxLength={maxLength}
          {...props}
        />

        {icon && (
          <div className="absolute start-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
            {icon}
          </div>
        )}
      </div>

      <div className="flex justify-between mt-1">
        {error && (
          <span className="text-sm text-red-600">
            {error}
          </span>
        )}

        {showCounter && maxLength && (
          <span className={`text-sm ms-auto ${
            value?.length >= maxLength ? 'text-red-600' : 'text-gray-500'
          }`}>
            {value?.length || 0} / {maxLength}
          </span>
        )}
      </div>
    </div>
  );
};

export default Input;